import Const from 'const';
import {FilterLineupsByPlayerInterface} from 'components/molecules/filter-lineups-by-player/filter-lineups-by-player-interface';

class FilterLineupsByPlayer implements FilterLineupsByPlayerInterface {
    constructor(
        public readonly checkedPlayers: object = {},
        public readonly lineupIds: string[] = [],
        public readonly usedPlayerIds: string[] = [],
    ) {}
    hasCheckedPlayers(): boolean {
        return !isEmpty(this.checkedPlayers);
    }
    isPlayerChecked(playerId: number): boolean {
        return playerId in this.checkedPlayers && !isEmpty(this.checkedPlayers[playerId]);
    }
    isPlayerCheckedOnLineupRoles(playerId: string, lineupRoles: string[] | string): boolean {
        lineupRoles = Array.isArray(lineupRoles) ? lineupRoles : [lineupRoles];

        return (
            playerId in this.checkedPlayers &&
            isEmpty(arrayDiff(lineupRoles, Object.keys(this.checkedPlayers[playerId])))
        );
    }
    getLineupIds(): string[] {
        return this.lineupIds;
    }
    getLineupsQuantity(): number {
        return this.lineupIds.length;
    }
    getUsedPlayerIds(): string[] {
        return this.usedPlayerIds;
    }
    getUsedPlayersQuantity(): number {
        return this.usedPlayerIds.length;
    }
}

const filterLineupsByPlayer = new FilterLineupsByPlayer();

export default function (state = filterLineupsByPlayer, action) {
    switch (action.type) {
        case Const.FILTER_LINEUPS_BY_PLAYERS_SET_PLAYER:
            const {checkedPlayers, lineupIds, usedPlayerIds} = action.data;

            return new FilterLineupsByPlayer(checkedPlayers, lineupIds, usedPlayerIds);

        case Const.FILTER_LINEUPS_BY_TEAM_COMBINATIONS_SET_COMBO:
        case Const.FILTER_LINEUPS_BY_CORRELATION_STACK_COMBINATIONS_SET_COMBO:
        case Const.FILTER_LINEUPS_BY_KEY_PLAYER_STACK_COMBINATIONS_SET_COMBO:
        case Const.UNSET_LINEUPS:
        case Const.RESET_ALL_SETTINGS:
        case Const.FILTER_BY_SLATE:
            return new FilterLineupsByPlayer();

        default:
            return state;
    }
}
